import { Fragment } from 'react';
import { t, tx } from '../../i18n';
import { useClientApp } from '../context';
import { appChat, shortRole, writableContacts } from './data';

// Box „Ihre Kanzlei“ in der Seitenleiste: beschreibbare Ansprechpartner (aller Firmen, jede Person einmal), dann Telefon.
export function KanzleiContactsBox() {
  const { config } = useClientApp();
  const contacts = writableContacts(appChat.useData());
  return (
    <div className="help">
      <b>{t('Ihre Kanzlei')}</b>
      {contacts.map((c) => (
        <Fragment key={c.id}>
          {c.name} ({tx(shortRole(c.role))})
          <br />
        </Fragment>
      ))}
      {config.kanzleiPhone && <a href={`tel:${config.kanzleiPhone.replace(/[^\d+]/g, '')}`}>{config.kanzleiPhone}</a>}
    </div>
  );
}
